export const QueryKey = {
  GET_CONTENT_DETAIL: 'getContentDetail' as const,
};

export const ReactQueryKey = {
  contents: (id: string) => [QueryKey.GET_CONTENT_DETAIL, id] as const,
};
